var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingComfortModeActiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.09375,0.90625c-2.1699219-2.1738281-7.5400391-0.3662109-15.9550781,5.3808594 c-7.4697266,5.1015625-17.5644531,13.7246094-26.3457031,22.5058594c-3.6652222,3.6652222-3.8292847,9.543335-0.5361328,13.5361328 l-4.2138672,4.2138672l1.4140625,1.4140625l4.2142944-4.2142944c1.8953857,1.5631714,4.2144165,2.3490601,6.5210571,2.3490601 c2.5527344,0,5.0898438-0.9599609,7.0146484-2.8847656c8.1162109-8.1152344,17.7910156-19.4414062,22.5058594-26.3457031 C47.4580078,8.4482422,49.2685547,3.0791016,47.09375,0.90625z M40.0605469,15.734375 C35.40625,22.5498047,25.8330078,33.7519531,17.7929688,41.7929688c-2.8317871,2.8327026-7.5203247,2.9891357-10.6941528,0.5222778 l19.6082153-19.6082153l-1.4140625-1.4140625L5.6848755,40.901062c-2.4668579-3.1743774-2.3106079-7.8612671,0.5221558-10.6940308 C14.90625,21.5078125,24.8916016,12.9746094,32.265625,7.9394531c6.4960938-4.4355469,10.4169922-5.9580078,12.2939453-5.9580078 c0.5351562,0,0.9052734,0.1240234,1.1201172,0.3388672C46.6503906,3.2910156,45.7617188,7.3857422,40.0605469,15.734375z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingComfortModeActiveMedium);
export default __webpack_public_path__ + "static/media/parking-comfort-mode-active--medium.3c4def6efdc7386ef801c56322932d41.svg";
export { ForwardRef as ReactComponent };